var SOHO = SOHO || {};

jQuery(document).ready(function($) {
  var swiper = new Swiper(".swiper-container", {
    autoplay:
      autoscroll.home_banner_auto_scroll === "1" ? { delay: 3000 } : false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      renderBullet: function(index, className) {
        return '<span class="' + className + '">' + (index + 1) + "</span>";
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    loop: true,
  });

  // Call to Tooltip
  $('[data-toggle="tooltip"]').tooltip();

  // Resize Boxes
  var count_div_tel;
  if (count_div_tel != null) {
    resizeBoxesContact(count_div_tel);
  }

  /* Restore selected models */
  if (ajax_filter_params.query_params.car_model_slug != "") {
    // Verificar si car_model_slug es un array o un string
    let carModels = [];

    if (Array.isArray(ajax_filter_params.query_params.car_model_slug)) {
      // Si ya es un array, usarlo directamente
      carModels = ajax_filter_params.query_params.car_model_slug;
    } else if (
      typeof ajax_filter_params.query_params.car_model_slug === "string"
    ) {
      // Si es string, dividirlo por +
      carModels = ajax_filter_params.query_params.car_model_slug.split("+");
    }

    // Procesar cada modelo
    carModels.forEach(function(model) {
      if (model && model !== "todos") {
        selectedModel = document.querySelectorAll(
          "input[name='car_model[]'][value='" + model + "']"
        );
        selectedModel.forEach(function(item) {
          item.checked = true;
          item.classList.add("inp-car-check");
          item.classList.add("checked");
        });
      }
    });
  }
  if (
    ajax_filter_params.query_params.brand_name != "" &&
    ajax_filter_params.query_params.brand_name != "todos" &&
    document.querySelectorAll("select[name=brand_name]")
  ) {
    document
      .querySelectorAll("select[name=brand_name]")
      .forEach(function(item) {
        item.value = ajax_filter_params.query_params.brand_name;
      });
  }
  if (ajax_filter_params.query_params.year != 0) {
    document.querySelectorAll("select[name=car_year]").forEach(function(item) {
      item.value = ajax_filter_params.query_params.car_year;
    });
  }
  //console.log('valor de: '+ajax_filter_params.query_params.special_sale)
  //special_sale
  /* if(ajax_filter_params.query_params.special_sale != "" && ajax_filter_params.query_params.special_sale != "todos") {
        console.log('valor de: '+ ajax_filter_params.query_params.special_sale)
        document.querySelector("input[name=special_sale]").checked = true
    } */

  if (ajax_filter_params.query_params._ceswp_transmission != "") {
    document.querySelector(
      "input[name=_ceswp_transmission][value=" +
        ajax_filter_params.query_params._ceswp_transmission +
        "]"
    ).checked = true;
    document
      .querySelectorAll("select[name=_ceswp_transmission]")
      .forEach(function(item) {
        item.value = ajax_filter_params.query_params._ceswp_transmission;
      });
  }

  // Restaurar marcas seleccionadas de la URL
  if (
    ajax_filter_params.query_params.brand_name != "" &&
    ajax_filter_params.query_params.brand_name != "todos"
  ) {
    // Verificar si brand_name es un array o un string
    let brandNames = [];

    if (Array.isArray(ajax_filter_params.query_params.brand_name)) {
      // Si ya es un array, usarlo directamente
      brandNames = ajax_filter_params.query_params.brand_name;
    } else if (typeof ajax_filter_params.query_params.brand_name === "string") {
      // Si es string, dividirlo por +
      brandNames = ajax_filter_params.query_params.brand_name.split("+");
    }

    // Procesar cada marca
    brandNames.forEach(function(brand) {
      if (brand && brand !== "todos") {
        const brandInputs = document.querySelectorAll(
          "input[name='brand_name[]'][value='" + brand + "']"
        );
        brandInputs.forEach(function(input) {
          input.checked = true;
          const parentContainer = input.closest(".checkbox_brands");
          if (parentContainer) {
            parentContainer.classList.add("checked");
          }

          // Mostrar los modelos de esta marca
          $(".containerModel_" + input.value).css("display", "block");
          $(".js__" + input.value).removeClass("d-none");
        });
      }
    });
  }

  // Restaurar categorías (car_class) seleccionadas de la URL
  if (
    ajax_filter_params.query_params.car_class != "" &&
    ajax_filter_params.query_params.car_class != "todos"
  ) {
    // Verificar si car_class es un array o un string
    let carClasses = [];

    if (Array.isArray(ajax_filter_params.query_params.car_class)) {
      // Si ya es un array, usarlo directamente
      carClasses = ajax_filter_params.query_params.car_class;
    } else if (typeof ajax_filter_params.query_params.car_class === "string") {
      // Si es string, dividirlo por +
      carClasses = ajax_filter_params.query_params.car_class.split("+");
    }

    // Procesar cada clase de vehículo
    carClasses.forEach(function(carClass) {
      if (carClass && carClass !== "todos") {
        const classInputs = document.querySelectorAll(
          "input[name='car_class[]'][value='" + carClass + "']"
        );
        classInputs.forEach(function(input) {
          input.checked = true;
          const parentContainer = input.closest(".step-border");
          if (parentContainer) {
            parentContainer.classList.add("checked");
          }
        });
      }
    });
  }
});

$(window).on("load", function() {
  //Slider gallery ficha Nuevo
  if ($(".slider-gallery-ext").length) {
    $(".slider-gallery-ext").slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      dotsClass: "slick-dots",
      rows: 2,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 580,
          settings: {
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            rows: 1,
          },
        },
      ],
    });
  }

  if ($(".slider-gallery-int").length) {
    $(".slider-gallery-int").slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      dotsClass: "slick-dots",
      rows: 2,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 580,
          settings: {
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            rows: 1,
          },
        },
      ],
    });
  }

  $('a[data-toggle="tab"]').on("shown.bs.tab", function(e) {
    if ($(".slider-gallery-ext").length)
      $(".slider-gallery-ext").slick("setPosition");
    if ($(".slider-gallery-int").length)
      $(".slider-gallery-int").slick("setPosition");
  });

  //Loading Page
  $("#preloader").fadeOut("slow");

  $(".slides").on("setPosition", function() {
    $(this)
      .find(".slick-slide")
      .height("auto");
    var slickTrack = $(this).find(".slick-track");
    var slickTrackHeight = $(slickTrack).height();
    $(this)
      .find(".slick-slide")
      .css("height", slickTrackHeight + "px");
  });

  $(".collapse").collapse("hide");

  $("#phone").mask("+56 9 dddd dddd", { placeholder: "+56 9 1234 5678" });
  $(".price-value").mask("#.##d", { reverse: true, placeholder: "$" });

  $(".card-header h5").click(function(e) {
    $(this)
      .closest(".card")
      .addClass("active");
  });

  $("#search-filter h5 a").click(function(e) {
    $(this)
      .find("i.white")
      .toggleClass("icon-arrowUp");
  });

  $(".menu-item-has-children").hover(function() {
    $(this).toggleClass("open-sub-menu");
  });

  var consname = $("#footer .box-name span").text().length;
  var headername = $("#header .box-name").text().length;
  var branchemail = $(".item-branch-buttons .last-col span .medium");
  if (consname > 15) {
    $("#footer .box-name").addClass("extense-line");
  }
  if (headername > 15) {
    $("#header .box-name").addClass("extense-line");
  }

  branchemail.each(function() {
    if ($(this).text().length > 25) {
      $(this).addClass("sm-email");
    }
  });

  var branch = $(".cont-radio");
  branch.on("click", function() {
    branch.removeClass("checked");
    $(this).toggleClass("checked");
    $(this)
      .find("input[type=radio]")
      .prop("checked", true);
    $(".branch-error").hide();
  });

  //Vehiculos del home destacados
  if ($(".vehicles-slider").length) {
    // Calculamos el total de vehículos destacados antes de inicializar slick
    var $vehiclesFeatured = $(".vehicles-slider .slick-slide").length || 0;

    $(".vehicles-slider").slick({
      centerMode: $vehiclesFeatured <= 2,
      // centerPadding: '40px',
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: false,
      dots: true,
      dotsClass: "slick-dots",
      responsive: [
        {
          breakpoint: 1441,
          settings: {
            arrows: false,
            centerMode: $vehiclesFeatured <= 2,
            // centerPadding: '30px',
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 1100,
          settings: {
            arrows: false,
            centerMode: $vehiclesFeatured <= 2,
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            dots: true,
            centerMode: false,
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 580,
          settings: {
            arrows: false,
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
          },
        },
      ],
    });

    //Calculamos el total luego que se crea el slick
    $vehiclesFeatured = $(
      ".vehicles-slider .slick-list .slick-track > div.slick-slide"
    ).length;
  }

  //news Slider Noticias
  if ($(".news-slider").length) {
    // Iniciar con valor predeterminado seguro
    var $total_length = 0;

    $(".news-slider").slick({
      centerMode: false, // Cambiado a valor seguro por defecto
      // centerPadding: '40px',
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: false,
      dots: true,
      dotsClass: "slick-dots",
      responsive: [
        {
          breakpoint: 1441,
          settings: {
            centerMode: false,
            // centerPadding: '30px',
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 1100,
          settings: {
            centerMode: false,
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            dots: false,
            centerMode: false,
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 580,
          settings: {
            arrows: true,
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
          },
        },
      ],
    });

    $(".news-slider").slick("slickSetOption", "slidesToScroll", 4, true);
    $(".news-slider").on("beforeChange", function(
      event,
      slick,
      currentSlide,
      nextSlide
    ) {});
    $(".news-slider").on("afterChange", function(
      event,
      slick,
      currentSlide
    ) {});

    //Calculamos el total luego que se crea el slick
    $total_length = $(".news-slider .slick-list .slick-track > div.slick-slide")
      .length;
    // Actualizar centerMode solo después de tener el valor correcto
    $(".news-slider").slick(
      "slickSetOption",
      "centerMode",
      $total_length <= 2,
      true
    );
  }

  //Slick versiones en modelo
  if ($(".ftd-slider").length) {
    // Iniciar con valor predeterminado seguro
    var $vehicleList = 0;

    $(".ftd-slider").slick({
      centerMode: false, // Valor seguro por defecto
      // centerPadding: '40px',
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: false,
      dots: true,
      dotsClass: "slick-dots",
      responsive: [
        {
          breakpoint: 1441,
          settings: {
            arrows: false,
            centerMode: false,
            // centerPadding: '30px',
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 1100,
          settings: {
            arrows: false,
            centerMode: false,
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            dots: true,
            centerMode: false,
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 580,
          settings: {
            arrows: false,
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
          },
        },
      ],
    });

    //Calculamos el total luego que se crea el slick
    $vehicleList = $(
      ".vehicles-list-ficha .slick-list .slick-track > div.slick-slide"
    ).length;
    // Actualizar centerMode solo después de tener el valor correcto
    $(".ftd-slider").slick(
      "slickSetOption",
      "centerMode",
      $vehicleList <= 2,
      true
    );
  }

  // Inicializar branches_quantity de manera segura
  var branches_quantity = 0;

  if ($(".news-container").length) {
    $(".news-container")
      .slick({
        centerMode: false, // Valor seguro por defecto
        centerPadding: "20%",
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
        dots: true,
        dotsClass: "slick-dots",
        responsive: [
          {
            breakpoint: 870,
            settings: {
              arrows: false,
              centerMode: false,
              centerPadding: "20px",
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 670,
            settings: {
              arrows: false,
              dots: true,
              centerMode: true,
              centerPadding: "10px",
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      })
      .on("setPosition", function(event, slick) {
        slick.$slides.css("height", slick.$slideTrack.height() + "px");
      });

    $(".news-container").on("beforeChange", function(
      event,
      slick,
      currentSlide,
      nextSlide
    ) {});
    $(".news-container").on("afterChange", function(
      event,
      slick,
      currentSlide
    ) {});
  }

  if ($(".branches-list").not(".no-slick").length) {
    $(".branches-list")
      .not(".no-slick")
      .slick({
        centerMode: false, // Valor seguro por defecto
        //centerPadding: '60px',
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: false,
        dots: true,
        dotsClass: "slick-dots",
        autoplay:
          autoscroll.branches_home_autoscroll === "1" ? { delay: 3000 } : false,
        autoplaySpeed: 3000,
        responsive: [
          {
            breakpoint: 1441,
            settings: {
              arrows: false,
              centerMode: false,
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              dots: true,
              centerMode: false,
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 580,
            settings: {
              arrows: false,
              dots: true,
              centerMode: false,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      })
      .on("setPosition", function(event, slick) {
        slick.$slides.css("height", slick.$slideTrack.height() + "px");
      });

    $(".branches-list")
      .not(".no-slick")
      .slick("slickSetOption", "slidesToScroll", 2, true);

    $(".branches-list")
      .not(".no-slick")
      .on("beforeChange", function(event, slick, currentSlide, nextSlide) {});

    $(".branches-list")
      .not(".no-slick")
      .on("afterChange", function(event, slick, currentSlide) {});

    // Calcular branches_quantity después de inicializar slick
    branches_quantity = $(
      ".branches-list .slick-list .slick-track > div.slick-slide"
    ).length;

    // Ahora que tenemos el valor correcto, actualizar las configuraciones
    if (branches_quantity <= 2) {
      $(".branches-list .slick-dots").addClass("hidden-desktop");
      $(".branches-list")
        .not(".no-slick")
        .slick("slickSetOption", "centerMode", true, true);
    } else {
      $(".branches-list .slick-dots").removeClass("hidden-desktop");
    }

    if (branches_quantity <= 1) {
      $(".branches-list .slick-list .slick-track").addClass("no-translate");
      $(".news-container").slick("slickSetOption", "centerMode", true, true);
    } else {
      $(".branches-list .slick-list .slick-track").removeClass("no-translate");
    }
  }

  $(".exterior-container, .interior-container").slick({
    dots: true,
    dotsClass: "slick-dots",
    centerMode: false,
    centerPadding: "10px",
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: false,
          centerPadding: "10px",
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 580,
        settings: {
          arrows: false,
          centerMode: false,
          centerPadding: "20px",
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".slider-nav",
  });
  $(".slider-nav").slick({
    slidesToShow: 4,
    asNavFor: ".slider-for",
    dots: false,
    arrows: false,
    focusOnSelect: true,
    centerMode: true,
    centerPadding: "20px",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          slidesToShow: 3,
        },
      },
    ],
  });
  $(".slider-nav").on("beforeChange", function(
    event,
    slick,
    currentSlide,
    nextSlide
  ) {
    $(".slider-nav .slick-slide").removeClass("slick-current");
    $(".slider-nav .slick-slide:not(.slick-cloned)")
      .eq(currentSlide)
      .addClass("slick-current");
  });
  $(".slider-nav").on("afterChange", function(event, slick, currentSlide) {});

  /* var $colors_length = $('.slider-nav .slick-track .slick-slide').length;
    if ($colors_length == 1) {
        $('.slider-nav .slick-track').addClass('no-translate');
    } */

  //Desktop Sliders Auto Used gallery
  function slickInit() {
    $(".exterior-images").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      useTransform: false,
      centerMode: true,
      centerPadding: "0px",
      respondTo: "slider",
      asNavFor: ".exterior-thumbs",
    });
    $(".exterior-thumbs").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: ".exterior-images",
      focusOnSelect: true,
      arrows: false,
      dots: false,
      centerMode: false,
      centerPadding: "0px",
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: false,
            slidesToShow: 4,
          },
        },
      ],
    });
  }

  slickInit();

  var $exterior_thumbs = $(
    ".exterior-thumbs .slick-list .slick-track > div.slick-slide"
  ).length;
  if ($exterior_thumbs <= 6) {
    $(".exterior-thumbs .slick-list .slick-track").addClass(
      "no-translate-desktop"
    );
  } else {
    $(".exterior-thumbs .slick-list .slick-track").removeClass(
      "no-translate-desktop"
    );
  }

  $('a[data-toggle="tab"]').on("shown.bs.tab", function(e) {
    $(".exterior-images").slick("unslick");
    $(".exterior-thumbs").slick("unslick");
    slickInit();
  });

  //Slick Colores ficha
  $(".slider-for-desktop").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    centerMode: false,
    //centerPadding: '0px',
    asNavFor: ".slider-nav-desktop",
  });
  $(".slider-nav-desktop").slick({
    slidesToShow: $length_thumbs + 1,
    slidesToScroll: 1,
    asNavFor: ".slider-for-desktop",
    focusOnSelect: true,
    arrows: false,
    dots: false,
    centerMode: true,
    //centerPadding: '0px',
    infinite: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: $length_thumbs + 1,
          infinite: true,
          centerMode: true,
        },
      },
    ],
  });
  var $length_thumbs = $(
    ".slider-for-desktop .slick-list .slick-track > div.slick-slide"
  ).length;
});

$(window).scroll(function(e) {
  var $el = $(".sticky-search");
  var isPositionFixed = $el.css("position") == "fixed";
  if ($(this).scrollTop() > 250 && !isPositionFixed) {
    $(".sticky-search").css({ position: "fixed", top: "0px" });
    $(".sticky-search").addClass("sticky-shadow");
  }
  if ($(this).scrollTop() < 250 && isPositionFixed) {
    $(".sticky-search").css({ position: "relative", top: "0px" });
    $(".sticky-search").removeClass("sticky-shadow");
  }

  var $ft = $("#sticky-features");
  var isPositionFixedFt = $ft.css("position") == "fixed";
  if ($(this).scrollTop() > 900 && !isPositionFixedFt) {
    $("#sticky-features").css({
      position: "fixed",
      top: "0px",
      left: "0px",
      "padding-left": "15px",
      "padding-right": "15px",
    });
    $("#sticky-features").fadeIn("fast");
  }
  if ($(this).scrollTop() < 900 && isPositionFixedFt) {
    $("#sticky-features").css({
      position: "relative",
      top: "0px",
      "padding-left": "0px",
      "padding-right": "0px",
    });
    $("#sticky-features").hide("fast");
  }

  var $sd = $("#sticky-data");
  var isPositionFixedSd = $sd.css("position") == "fixed";
  if ($(this).scrollTop() > 635 && !isPositionFixedSd) {
    $sd.css({
      position: "fixed",
      display: "block",
      top: "0px",
      left: "0px",
      width: "100%",
      "z-index": "5000",
    });
    $sd.fadeIn("fast");
  }
  if ($(this).scrollTop() < 635 && isPositionFixedSd) {
    $sd.css({ position: "relative", display: "none", "padding-left": "0px" });
    $sd.hide("fast");
  }
});

//Fix for plugin WP Chat App
//var divForm = $('#search-vehicle-form');
//var divNewForm = $('#new-search-vehicle-form');
//var divNav = $('#main-nav');

$(function() {
  $("#open-nav").click(function() {
    //console.log('Abrir menu');
    $("#main-nav").removeClass("d-none");
    $("#main-nav").toggleClass("fadeOutUp");
    $("#main-nav").toggleClass("fadeInDown");
    $("#nav-icon").toggleClass("open");
    $(".menu-trigger-2").toggleClass("active");
    $("html,body").toggleClass("hidden-overflow");
    $("body").toggleClass("fixed-pos");
  });
  $("#close-menu-mobile").click(function() {
    $("#main-nav").removeClass("d-block");
    $("#main-nav").addClass("d-none");
    $("#main-nav").toggleClass("fadeOutUp");
    $("#main-nav").toggleClass("fadeInDown");
    $("#nav-icon").toggleClass("open");
    $(".menu-trigger-2").toggleClass("active");
    $("html,body").toggleClass("hidden-overflow");
    $("body").toggleClass("fixed-pos");
  });
  /* $('.open-new-search').click(function () {
        $('#new-search-vehicle-form').removeClass('d-none');
        $('#new-search-vehicle-form').removeClass('fadeOutUp');
        $('#new-search-vehicle-form').addClass('fadeInDown');
        $('.menu-trigger-2').attr('style', 'z-index: 2');
        $('html,body').attr('style', 'overflow: hidden');
        $('body').addClass('fixed-pos');
    });
    $('#close-search-used, #back-search-used').click(function () {
        $('#new-search-vehicle-form').removeClass('fadeInDown');
        $('#new-search-vehicle-form').addClass('fadeOutUp');
        $('.menu-trigger-2').attr('style', 'z-index: 1001');
        $('html,body').attr('style', 'overflow: inherit');
        $('body').attr('style', 'position: relative');
        $('body').removeClass('fixed-pos');
    }); */
  //Open collapse Busqueda Nuevos
  $(".open-new-search-news").click(function() {
    // Mostrar el modal de búsqueda
    $("#collapseFilter").collapse("show");

    // Si estamos en "no-results", ocultar el mensaje de no resultados
    if ($(".no-results").is(":visible")) {
      $(".no-results").addClass("d-none");
      $(".cont-search").removeClass("d-none");
    }

    // Ocultar botones de filtro y contador mientras se muestra el filtro
    $(".btn-filter-news").addClass("d-none");
    $(".title-count").addClass("d-none");
    $(".btn-filter-news").removeClass("d-block");
    $(".title-count").removeClass("d-block");

    // Hacer scroll hacia arriba para que el usuario vea el filtro
    $("html, body").animate(
      {
        scrollTop: $("#collapseFilter").offset().top - 100,
      },
      500
    );
  });
  $("#close-search-new").click(function() {
    $("#collapseFilter").collapse("hide");
    $(".btn-filter-news").addClass("d-block");
    $(".title-count").addClass("d-block");
  });
  //Open collapse Busqueda Usados
  $(".open-new-search-used").click(function() {
    $(".btn-filter-used").addClass("d-none");
    $(".title-count").addClass("d-none");
    $(".btn-filter-used").removeClass("d-block");
    $(".title-count").removeClass("d-block");
  });
  $("#close-search-used").click(function() {
    $("#collapseFilterUsed").collapse("hide");
    $(".btn-filter-used").addClass("d-block");
    $(".title-count").addClass("d-block");
  });
});

$(function() {
  $("#open-search").click(function() {
    $("#search-vehicle-form").removeClass("d-none");
    $("#search-vehicle-form").removeClass("fadeOutUp");
    $("#search-vehicle-form").addClass("fadeInDown");
    $(".menu-trigger-2").attr("style", "z-index: 2");
    $("html,body").attr("style", "overflow: hidden");
    $("body").addClass("fixed-pos");
  });
  $("#close-search, #back-search").click(function() {
    $("#search-vehicle-form").removeClass("fadeInDown");
    $("#search-vehicle-form").addClass("fadeOutUp");
    $(".menu-trigger-2").attr("style", "z-index: 1001");
    $("html,body").attr("style", "overflow: inherit");
    $("body").attr("style", "position: relative");
    $("body").removeClass("fixed-pos");
  });
});

// select
$(function() {
  var pricef = $("#pricefrom");
  var priceu = $("#priceuntil");
  var data = [];
  var data2 = [];

  // Generar opciones para pricefrom (price from)
  for (var i = 1; i <= 30; i++) {
    // Modificado hasta 60 millones
    data.push({
      id: String(i) + "000000",
      text: "$" + " " + String(i) + ".000.000",
    });
  }

  // Generar opciones para priceuntil (price until)
  for (var i = 31; i <= 60; i++) {
    // Comienza desde 31 millones
    data2.push({
      id: String(i) + "000000",
      text: "$" + " " + String(i) + ".000.000",
    });
  }

  $.each(data, function(i) {
    pricef.append(
      $("<option></option>")
        .val(data[i].id)
        .html(data[i].text)
    );
  });

  $.each(data2, function(i) {
    priceu.append(
      $("<option></option>")
        .val(data2[i].id)
        .html(data2[i].text)
    );
  });
  pricef.append($("<select>").html());
  priceu.append($("<select>").html());

  setTimeout(function() {
    str = $("#priceuntil option:selected").text();
    $("#old-value").text(str);
  }, 500);

  $("#priceuntil").change(function() {
    str = $("#priceuntil option:selected").text();
    $("#old-value").text(str);
  });

  //set value on load form query
  minVal = 1000000;
  maxVal = 60000000;
  price_min = ajax_filter_params.query_params.price_min;
  price_max = ajax_filter_params.query_params.price_max;
  price_min = price_min == "" || price_min == null ? minVal : price_min;
  price_max = price_max == "" || price_max == null ? maxVal : price_max;

  $("#pricefrom").val(price_min);
  $("#priceuntil").val(price_max);
});

/// check and replace url

$(function() {
  //Select branch on single page
  $("select[name=branch_address]").on("change", function() {
    var branch_city = $("select[name=branch_address] option:selected").attr(
      "data-branch-city"
    );
    var branch_email = $("select[name=branch_address] option:selected").attr(
      "data-branch-email"
    );
    var branch_phone = $("select[name=branch_address] option:selected").attr(
      "data-branch-phone"
    );

    $("input[name=branch_city]").attr("value", branch_city);
    $("input[name=subsidiary_email]").attr("value", branch_email);
    $("input[name=subsidiary_phone]").attr("value", branch_phone);
  });

  function updateFilterUrl($form) {
    var searchBasePage = ajax_filter_params.search_url;

    getFormBrandFilters = getFormBrandFilters();
    getFormBrandFilters =
      getFormBrandFilters.length > 0 ? getFormBrandFilters : ["todos"];
    //getFormMultiBrandFilters = getFormMultiBrandFilters(); //Multi Brands in used case (Under Construction)
    //getFormMultiBrandFilters = (getFormMultiBrandFilters.length > 0) ? getFormBrandFilters : ['todos'];-
    getFormClassFilters = getFormClassFilters();
    getFormClassFilters =
      getFormClassFilters.length > 0 ? getFormClassFilters : ["todos"];
    getFormModelFilters = getFormModelFilters();
    getFormModelFilters =
      getFormModelFilters.length > 0 ? getFormModelFilters : ["todos"];
    getFormYearFilters = getFormYearFilters();
    getFormYearFilters =
      getFormYearFilters.length > 0 ? getFormYearFilters : ["todos"];
    getFormTransmissionFilters = getFormTransmissionFilters();
    getFormTransmissionFilters =
      getFormTransmissionFilters.length > 0
        ? getFormTransmissionFilters
        : ["todos"];
    getFormSpecialSaleFilters = getFormSpecialSaleFilters();
    getFormSpecialSaleFilters =
      getFormSpecialSaleFilters.length > 0
        ? getFormSpecialSaleFilters
        : ["todos"];
    getFormCombustibleFilters = getFormCombustibleFilters();
    getFormCombustibleFilters =
      getFormCombustibleFilters.length > 0
        ? getFormCombustibleFilters
        : ["todos"];
    getFormTransmisionFilters = getFormTransmisionFilters();
    getFormTransmisionFilters =
      getFormTransmisionFilters.length > 0
        ? getFormTransmisionFilters
        : ["todos"];
    getFormOrderFilters = getFormOrderFilters();
    getFormOrderFilters =
      getFormOrderFilters.length > 0 ? getFormOrderFilters : ["asc"];

    var uniqueBrands = [];
    $.each(getFormBrandFilters, function(i, el) {
      if ($.inArray(el, uniqueBrands) === -1) uniqueBrands.push(el);
    });

    var uniqueClasses = [];
    $.each(getFormClassFilters, function(i, el) {
      if ($.inArray(el, uniqueClasses) === -1) uniqueClasses.push(el);
    });

    var uniqueModels = [];
    $.each(getFormModelFilters, function(i, el) {
      if ($.inArray(el, uniqueModels) === -1) uniqueModels.push(el);
    });

    var uniqueYears = [];
    $.each(getFormYearFilters, function(i, el) {
      if ($.inArray(el, uniqueYears) === -1) uniqueYears.push(el);
    });

    if (document.querySelector("body.page-template-page-search-used")) {
      var filters = {
        class: { label: "/", values: uniqueClasses },
        brand: { label: "/", values: uniqueBrands },
        year: { label: "/", values: uniqueYears },
        transmission: { label: "/", values: getFormTransmissionFilters },
        prices: { label: "/", values: getFormPriceFilters() },
      };
    } else {
      var filters = {
        class: { label: "/", values: uniqueClasses },
        brand: { label: "/", values: uniqueBrands },
        model: { label: "/", values: uniqueModels },
        prices: { label: "/", values: getFormPriceFilters() },
        special_sale: { label: "/", values: getFormSpecialSaleFilters },
        car_combustible: { label: "/", values: getFormCombustibleFilters },
        car_transmision: { label: "/", values: getFormTransmisionFilters },
        car_order: { label: "/", values: getFormOrderFilters },
      };
    }

    var formFiltersUrl = window.location.origin + "/" + searchBasePage;

    if (document.querySelector("body.page-template-page-search-used")) {
      formFiltersUrl += "/" + (uniqueClasses.join("+") || "todos");
      formFiltersUrl += "/" + (uniqueBrands.join("+") || "todos");
      formFiltersUrl += "/" + (uniqueYears.join("+") || "todos");
      formFiltersUrl += "/" + (getFormTransmissionFilters.join("+") || "todos");
      formFiltersUrl += "/" + getFormPriceFilters().join("+");
    } else {
      for (var filter in filters) {
        if (filters.hasOwnProperty(filter)) {
          var currentFilter = filters[filter];
          if (currentFilter.values.length) {
            formFiltersUrl +=
              currentFilter.label + currentFilter.values.join("+");
          }
        }
      }
    }

    $form.find("a").attr("href", formFiltersUrl);

    function getFormBrandFilters() {
      var brandFilter = [];
      $form.find("input[name$=brand_name\\[\\]]:checked").each(function() {
        if ($(this).val() === "todos") {
          brandFilter.push($(this).val());
          return false;
        } else {
          brandFilter.push($(this).val());
        }
      });
      var usedBrand = $form.find("select[name=brand_name]");
      if (usedBrand.length) {
        brandFilter.push(usedBrand[0].value);
      }
      //console.log(brandFilter)
      return brandFilter;
    }

    //Multiple Brands in Used case (Under Construction)
    function getFormMultiBrandFilters() {
      var brandFilter = [];
      $form.find(".js-select-brand:checked").each(function() {
        if ($(this).val() === "todos") {
          brandFilter.push($(this).val());
          return false;
        } else {
          brandFilter.push($(this).val());
        }
      });

      return brandFilter;
    }

    function getFormClassFilters() {
      var classFilter = [];
      var $carClass = $form.find("input[name$=car_class\\[\\]]:checked");
      $carClass.each(function() {
        if ($(this).val() === "todos") {
          classFilter.push($(this).val());
          return false;
        } else {
          classFilter.push($(this).val());
        }
      });
      return classFilter;
    }

    function getFormModelFilters() {
      var modelFilter = [];
      var $models = $form.find("input[name$=car_model\\[\\]]:checked");

      $models.each(function() {
        if ($(this).val() === "todos") {
          modelFilter.push($(this).val());
          return false;
        } else {
          modelFilter.push($(this).val());
        }
      });

      return modelFilter;
    }

    function getFormPriceFilters() {
      return [
        $form.find(".price_min").val(), //, #pricefrom, #lv
        $form.find(".price_max").val(), //, #priceuntil, uv
      ];
    }

    function getFormYearFilters() {
      var usedYear = $form.find("select[name=car_year]");
      if (usedYear.length) {
        return [usedYear[0].value];
      } else {
        return [];
      }
    }
    //get special_sale checked
    function getFormSpecialSaleFilters() {
      var specialSale = $form.find(
        "input[name=special_sale]:checked, select[name=special_sale]"
      );
      if (specialSale[0]) {
        //console.log('special_sale: ' + specialSale[0].value);
        return [specialSale[0].value];
      } else {
        return [];
      }
    }

    function getFormTransmissionFilters() {
      var usedTransmission = $form.find(
        "input[name=_ceswp_transmission]:checked, select[name=_ceswp_transmission]"
      );
      if (usedTransmission[0]) {
        return [usedTransmission[0].value];
      } else {
        return [];
      }
    }

    function getFormCombustibleFilters() {
      var combustibleFilter = [];
      var $combustibles = $form.find("input[name=car_combustible]:checked");

      $combustibles.each(function() {
        if ($(this).val() === "todos") {
          combustibleFilter.push($(this).val());
          return false;
        } else {
          combustibleFilter.push($(this).val());
        }
      });

      //console.log(combustibleFilter)
      return combustibleFilter;
    }
    function getFormTransmisionFilters() {
      var transmisionFilter = [];
      var $transmisiones = $form.find("input[name=car_transmision]:checked");

      $transmisiones.each(function() {
        if ($(this).val() === "todos") {
          transmisionFilter.push($(this).val());
          return false;
        } else {
          transmisionFilter.push($(this).val());
        }
      });
      return transmisionFilter;
    }
    /* function getFormClassFilters() {
            var classFilter = [];
            var $carClass = $form.find("input[name$=car_class\\[\\]]:checked");
            $carClass.each(function () {
                if ($(this).val() === 'todos') {
                    classFilter.push($(this).val());
                    return false;
                } else {
                    classFilter.push($(this).val());
                }
            });
            console.log(classFilter)
            return classFilter;
        } */

    function getFormOrderFilters() {
      var orderFilter = [];
      var $order = $form.find("input[name=car_order]:checked");

      $order.each(function() {
        if ($(this).val() === "todos") {
          orderFilter.push($(this).val());
          return false;
        } else {
          orderFilter.push($(this).val());
        }
      });
      return orderFilter;
    }
  }

  //Forms
  $form_primary = $("form#searchform");
  $form_home_mobile = $("form#searchformMobileHome");
  $form_search_mobile = $("form#searchformMobile");

  //Update filter on load
  setTimeout(function() {
    updateFilterUrl($form_primary);
    updateFilterUrl($form_home_mobile);
    updateFilterUrl($form_search_mobile);
  }, 500);

  $(".submitSearch").click(function() {
    updateFilterUrl($form_primary);
    updateFilterUrl($form_home_mobile);
    updateFilterUrl($form_search_mobile);
  });

  $("form :input").on("change", function() {
    updateFilterUrl($form_primary);
    updateFilterUrl($form_home_mobile);
    updateFilterUrl($form_search_mobile);
  });

  ///range
  // check if is mobile, otherwise delete element
  var resolucion = window.screen.width;
  if (resolucion > 767) {
    $("[data-nouislider-mobile]").empty();
  } else {
    $("[data-nouislider-desktop]").empty();
  }

  var $slider = $("#range").get(0);
  var minVal = 1000000;
  var maxVal = 60000000;

  price_min = ajax_filter_params.query_params.price_min;
  price_max = ajax_filter_params.query_params.price_max;
  price_min = price_min == "" || price_min == null ? minVal : price_min;
  price_max = price_max == "" || price_max == null ? maxVal : price_max;

  if (!$slider) return true;

  noUiSlider.create($slider, {
    start: [price_min, price_max],
    step: 1000000,
    connect: true,
    tooltips: true,
    range: {
      min: minVal,
      max: maxVal,
    },
    format: wNumb({
      prefix: "$ ",
      decimals: 3,
      thousand: ".",
    }),
  });

  var nodes = [
    document.getElementById("lower-value"), // 0
    document.getElementById("upper-value"), // 1
  ];

  $slider.noUiSlider.on("update", function(values, handle) {
    setTimeout(function() {
      updateFilterUrl($form_primary);
      updateFilterUrl($form_home_mobile);
      updateFilterUrl($form_search_mobile);
    }, 500);
    nodes[handle].innerHTML = values[handle];
    $("#lower-value").attr("value", values[0]);
    $("#lv").attr("value", values[0].replace(/[^0-9]/g, ""));
    $("#upper-value").attr("value", values[1]);
    $("#uv").attr("value", values[1].replace(/[^0-9]/g, ""));
  });
  $(".noUi-tooltip").each(function() {
    // do something
  });
});

// resize boxes of contact in card of branches
function resizeBoxesContact(cant_div) {
  var id_div = 0;
  var comp_id_div = 0;

  for (var index = 1; index <= cant_div; index++) {
    id_div = $("#div_tel_" + index);

    if (id_div.height() > comp_id_div) {
      comp_id_div = id_div.height();
    } else {
      id_div.height(comp_id_div);
    }
  }
}

// Funxx anonima ejecuta despligue y cierre de la modal que muestra los telefonos de las sucursales

var viewPhones = $("#view-phones");

$(function() {
  $(".open-view-phones").click(function() {
    getTelephones($(this).data("count-card"));

    viewPhones.removeClass("d-none");
    viewPhones.removeClass("fadeOutUp");
    viewPhones.addClass("fadeInDown");
    $(".menu-trigger-2").css({ "z-index": "2", position: "initial" });
    $(".main-section").attr("style", "position: unset");
    $("body").addClass("hidden-overflow");
    $("#sticky-features").attr("style", "position: initial");
  });

  $("#close-view-phones").click(function() {
    viewPhones.removeClass("d-none");
    viewPhones.addClass("fadeOutUp");
    viewPhones.removeClass("fadeInDown");
    $(".menu-trigger-2").css({ "z-index": "10001", position: "fixed" });
    $(".main-section").attr("style", "position: relative");
    $("body").removeClass("hidden-overflow");
    $("#sticky-features").css({
      position: "fixed",
      top: "0px",
      "padding-left": "15px",
      "padding-right": "15px",
      left: "0px",
      display: "block",
    });
  });
});

// Funxx obtiene los telefonos desde cada sucursal al momoento de hacer tap (mobile)
function getTelephones(dataPhones) {
  $("div.card-container > .card").remove();

  dataPhones.forEach(function(services) {
    var countPhones = 0;

    services.telefonos_servicio.forEach(function(phones) {
      countPhones++;
      var htmlPhones =
        '<a href="tel:' +
        phones.ceswp_telefono_servicio +
        '" class="col-12 card mt-3"> <div class="card-header text-left"><h6 class="mb-0">' +
        services.ceswp_services_contact +
        " " +
        countPhones +
        '</h6></div><div class="card-content text-left"><h5 class="t16">' +
        phones.ceswp_telefono_servicio +
        "</h5></div></a>";
      $(".card-container").append(htmlPhones);
    });
  });
}

//Display models based on brand checked on mobile search

var brandInputs = $(".js_send_checked_for_models");

brandInputs.on("click", function() {
  $(".js__models").addClass("d-none");
  unselectModels();
  var $brandSelector = $("input[name='brand_name[]']:checked");
  if ($brandSelector.length === 0) {
    $(".js__models").removeClass("d-none");
  } else {
    $brandSelector.each(function() {
      $(".js__" + $(this).val()).removeClass("d-none");
    });
  }
});

$(function() {
  //Show selected brand models
  $("input[name='brand_name[]']").on("click", function() {
    var showAllBrands = true;

    $('div[class^="containerModel_"]').css("display", "none");
    $(".brandContainer").each(function() {
      $input = $(this).find("input[name='brand_name[]']");
      if ($input.prop("checked")) {
        $(".containerModel_" + $input.val()).css("display", "block");
        showAllBrands = false;
      }
    });

    $(".brandContainer-mobile").each(function() {
      $input = $(this).find("input[name='brand_name[]']");
      if ($input.prop("checked")) {
        $(".containerModel_" + $input.val()).css("display", "block");
        showAllBrands = false;
      }
    });
    if (this.checked) {
      $(".js__" + $(this).val()).removeClass("d-none");
    }
    if (!this.checked) {
      $(".js__" + $(this).val()).addClass("d-none");
    }

    // Updates mobile inputs check's
    var mobileInputs = $(
      ".brandContainer-mobile input[value=" + this.value + "]"
    );
    if (mobileInputs.length > 0) {
      mobileInputs[0].checked = this.checked;
    }

    $(".containerModel_" + $(this).val()).each(function() {
      $(this)
        .find("input")
        .prop("checked", false);
    });

    if (showAllBrands) {
      $(".containerAllModels")
        .removeClass("containerAllModelsShow")
        .addClass("containerAllModelsHide");
      $('div[class^="containerModel_"]').css("display", "block");
      $(".js__models").each(function() {
        $(this).removeClass("d-none");
      });
    } else {
      $(".containerAllModels")
        .removeClass("containerAllModelsHide")
        .addClass("containerAllModelsShow");
    }
  });

  $("input[name='car_model[]']").on("click", function() {
    var input = $(this);
    modelsSelector(input);
  });

  $(".car-check-mobile").on("click", function() {
    var input = $(this).siblings("input");

    if (input.val() === "todos" && !input.prop("checked")) {
      $(".modelCheck")
        .prop("checked", false)
        .removeClass("inp-car-check checked");
    } else {
      $(".allCheck")
        .prop("checked", false)
        .removeClass("inp-car-check checked");
    }

    if (input.prop("checked")) {
      input.removeClass("inp-car-check checked");
      if (!input.hasClass("checked")) {
        input.is("checked", false);
      }
    } else {
      input.addClass("inp-car-check checked");
      if (input.hasClass("checked")) {
        input.is("checked", true);
      }
    }
  });
});

function modelsSelector(input) {
  if (!input.prop("checked")) {
    input.removeClass("inp-car-check checked");
    if (!input.hasClass("checked")) {
      input.is("checked", false);
    }
  } else {
    input.addClass("inp-car-check checked");
    if (input.hasClass("checked")) {
      input.is("checked", true);
    }
  }
}

//Unselect models on display
function unselectModels() {
  $(".js__remove_checkbox")
    .find("input[name='car_model[]']:checked")
    .removeAttr("checked");
}

// Home Branches phone contact data scard
$(".open-phones-card").on("click", function() {
  $(".overlay-phone-" + $(this).data("number")).addClass("open");
});

// Home Branches email contact data scard
$(".open-email-card").on("click", function() {
  $(".overlay-email-" + $(this).data("number")).addClass("open");
});

$(".close-item-contact-data").on("click", function() {
  $(this)
    .parent(".item-contact-data")
    .removeClass("open");
});

$(".branches-list").on("beforeChange", function(
  event,
  slick,
  currentSlide,
  nextSlide
) {
  $(".item-contact-data").removeClass("open");
});

//collapse specs
var equalizeRowsHeight = $(".collapsible-header");
var elementCollapse = document.querySelector(".collapsible-header");
equalizeRowsHeight.on("click", function() {
  var idCollapsibleBody = elementCollapse.getAttribute("data-category"); // Getter data-category
  let firstColumnRows = document.querySelectorAll(
    "#collapsible-" +
      idCollapsibleBody +
      " .custom-table-first-column-container .custom-table-tr"
  );
  let secondColumnRows = document.querySelectorAll(
    "#collapsible-" +
      idCollapsibleBody +
      " .custom-table-other-columns-container .custom-table-tr"
  );
  firstColumnRows.forEach((firstColumnRow, index) => {
    let firstColumnRowHeight = firstColumnRow.offsetHeight;
    let secondColumnRowHeight = secondColumnRows[index].offsetHeight;
    firstColumnRow.style.height = "auto";
    secondColumnRows[index].style.height = "auto";
  });

  setTimeout(() => {
    firstColumnRows.forEach((firstColumnRow, index) => {
      let firstColumnRowHeight = firstColumnRow.offsetHeight;
      let secondColumnRowHeight = secondColumnRows[index].offsetHeight;

      if (firstColumnRowHeight > secondColumnRowHeight) {
        secondColumnRows[index].style.height = firstColumnRowHeight + "px";
      } else {
        firstColumnRow.style.height = secondColumnRowHeight + "px";
      }
    });
  }, 100);
});

$(document).ready(function() {
  //Cargando specs de las versiones ficha modelo
  let firstColumnRows = document.querySelectorAll(
    ".custom-table-first-column-container .custom-table-tr"
  );
  let secondColumnRows = document.querySelectorAll(
    ".custom-table-other-columns-container .custom-table-tr"
  );

  firstColumnRows.forEach((firstColumnRow, index) => {
    let firstColumnRowHeight = firstColumnRow.offsetHeight;
    let secondColumnRowHeight = secondColumnRows[index].offsetHeight;

    if (firstColumnRowHeight > secondColumnRowHeight) {
      secondColumnRows[index].style.height = firstColumnRowHeight + "px";
    } else {
      firstColumnRow.style.height = secondColumnRowHeight + "px";
    }
  });

  $(".js-toggle-view-more").on("click", function(e) {
    e.preventDefault();
    var buttonHeight = 32;
    var margin = 14;
    var $cardTextWrapper = $(this).parents(".card-text-wrapper");
    $cardTextWrapper.toggleClass("expanded");

    if ($cardTextWrapper.hasClass("expanded")) {
      var heightParagaph =
        $(this)
          .siblings("p")
          .height() +
        buttonHeight +
        margin;
      $cardTextWrapper.css("height", heightParagaph + "px");
    } else {
      $cardTextWrapper.css("height", "100px");
    }
  });
});

// Home Branches phone contact data scard
$(".open-phones-card").on("click", function() {
  $(".overlay-phone-" + $(this).data("number")).addClass("open");
});

// Home Branches email contact data scard
$(".open-email-card").on("click", function() {
  $(".overlay-email-" + $(this).data("number")).addClass("open");
});

$(".close-item-contact-data").on("click", function() {
  $(this)
    .parent(".item-contact-data")
    .removeClass("open");
});

$(".branches-list").on("beforeChange", function(
  event,
  slick,
  currentSlide,
  nextSlide
) {
  $(".item-contact-data").removeClass("open");
});

// Modal
$(document).ready(function() {
  if (document.getElementById("home-modal")) {
    $("#home-modal").modal("show");
    document
      .querySelector(".modal-close")
      .addEventListener("click", function() {
        $("#home-modal").modal("hide");
      });
  }
});

//accordion sevices
$("#accordion_services").on("hidden.bs.collapse shown.bs.collapse", (e) => {
  $(e.target)
    .prev()
    .find("i:last-child")
    .toggleClass("fa-plus fa-minus");
});

//function show modal and print data inbound of function showBenefits
function showBenefits(data) {
  var modal = $("#modalBenefits");
  var modalBody = modal.find(".modal-body");
  var modalImage = modal.find(".modal-image");
  modalImage.attr("src", data.image);

  var modalTitle = modal.find(".modal-title");
  modalTitle.text(data.model);

  var modalSubtitle = modal.find(".modal-subtitle");
  modalSubtitle.text(data.version);

  var btnShowModel = modal.find(".btn-show-model");
  btnShowModel.attr("href", data.link_show_model);

  var btnQuotation = modal.find(".btn-quotation");
  btnQuotation.attr("href", data.link_quotation);

  modalBody.empty();
  const badges = JSON.parse(data.badges);

  $.each(badges, function(index, value) {
    modalBody.append('<p class="title mb-0">' + value.title + "</p>");
    if (value.description) {
      modalBody.append('<p class="description">' + value.description + "</p>");
    }
  });
  modal.modal("show");
}
